import React from "react";
import {
  FlexRowBetween,
  Label,
  MediumFont,
  PopupForm,
  TextWithPic,
} from "../../../common/Style";
import vi from "../../../../assets/common/vi.svg";
import ix from "../../../../assets/common/ix.svg";

const WasInvited = ({ func, init }) => {
  return (
    <PopupForm onClick={(e) => e.stopPropagation()}>
      <div
        style={{
          width: "90%",
          margin: "15px auto",
        }}
      >
        <Label style={{ width: "100%", textAlign: "center" }}>
          מעקב שליחת הזמנות
        </Label>
        <FlexRowBetween style={{ margin: "10px auto", marginTop: "30px" }}>
          <TextWithPic
            onClick={() => func({ wasInvited: true }, init)}
            style={{ padding: "3px 15px" }}
          >
            <MediumFont>הזמנתי</MediumFont>
            <img
              src={vi}
              alt="vi"
              style={{ width: "30px", marginRight: "20px" }}
            />
          </TextWithPic>
          <TextWithPic onClick={() => func({ wasInvited: false }, init)}>
            <MediumFont style={{ width: "max-content" }}>לא הזמנתי</MediumFont>
            <img
              src={ix}
              alt="ix"
              style={{ width: "20px", marginRight: "20px" }}
            />
          </TextWithPic>
        </FlexRowBetween>
      </div>
    </PopupForm>
  );
};

export default WasInvited;
